/* Copyright (c) Trimble Inc. All rights reserved. */

import type { EnvironmentConfig } from '../types/environment.model';

export const environment: EnvironmentConfig = {
  auth: {
    clientId: '1afc26d1-2fa2-4b0e-a6b1-102c1dc9c7f4',
    environment: 'PRODUCTION',
    scopes: ['openid', 'developerconsole', 'iam', 'connect'],
  },
  iamRoles: [
    {
      id: ['46a891b1-7ba1-4f0d-bc73-f250baa6d3b8'],
      name: 'Administrator',
    },
    {
      id: ['91cc5d37-690e-4694-8924-65cd37923404'],
      name: 'Developer',
    },
  ],
  emailTemplates: {
    joinTeamApprove: {
      templateId: '9d9e71fd68fe40ff8fdab55fd070b10b',
    },
    joinTeamReject: {
      templateId: '61621a4d9eab4fd9bc86347e9a498d3e',
    },
    acceptTeamInviteAdminNotification: {
      templateId: '2fa980b7335c4fe88933ffad2bcd6377',
    },
    rejectTeamInviteAdminNotification: {
      templateId: '9d22404ea30343b3b3a54f71b8c20557',
    },
    selfJoinTeam: {
      templateId: '71aaeced005a4972a57b30eecfa20b6c',
      variables: {
        review_url: 'https://console.developer.trimble.com/home/notifications',
      },
    },
    changeRole: {
      templateId: 'a02b4ffea8594a28ba0716f7d4544b19',
    },

    addMemberExistingConsoleUser: {
      templateId: '5b0fdb8437724900b0ecd832a1db3b39',
    },
    addMemberExistingTidUser: {
      templateId: '4c949c04d0574b6db72a4190b5250810',
    },
    addMemberNewTidUser: {
      templateId: 'a84b748cfcbc49caacfd354cbb9dfc32',
    },
    removeExistingMemberFromTeam: {
      adminTemplateId: '7e426b6b11624e6a8019800312c791e7',
      userTemplateId: '57e57e920ef44d21ad759f4061a403fe',
    },
  },
  environment: 'PRODUCTION',
  GuestRoleID: '476f440c-d2d8-4fba-a533-356fbb6ecb1d',
  applicationAuthorizationPermissionId: '7188f57a-9b56-4ef0-9439-dfe06043f1d8',
  adminConsoleBaseURL: 'https://accounts.trimble.com',

  clients: [
    {
      name: 'apicloud',
      baseUrl: 'https://developer-console.api.trimblecloud.com',
    },
    {
      name: 'iam',
      baseUrl: 'https://developer-console.api.trimblecloud.com/iam',
    },
    {
      name: 'validation',
      baseUrl: 'https://cloud.api.trimblecloud.com/business-systems/validation-api/1.0',
    },
  ],
  featureFlags: {
    enableMarketplaceIntegration: true,
    enableDxIntegration: true,
    enableApplicationExtension: true,
    enableSandbox: false,
    enableInternalUserRedirect: true,
    enableMswMocking: false,
    enableMultiAccountAuthorization: true,
    enableApplicationAuthorization: true,
    enableTaxInformation: false,
  },
  application: {
    baseUrl: 'https://console.developer.trimble.com',
    internalConsoleBaseUrl: 'https://console.trimble.com/',
    name: 'Developer Console',
  },
  appDirect: {
    baseUrl: 'https://partner-marketplace.trimble.com',
    publicMarketplaceBaseUrl: 'https://marketplace.trimble.com',
  },
  gainsight: {
    enabled: true,
    productKey: 'AP-SYGGVVGZCVPY-2',
  },
  accountOwnerRoleIds: {
    primary: '9c39877-26f6-482c-a35f-53f68c952374',
    secondary: '5fac689e-ce34-4a8d-91c8-e0bdfcac6e92',
  },
};
